var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 41,
    viewBox: "0 0 42 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.870117,
    y: 0.5,
    width: 40.2149,
    height: 40,
    rx: 4.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7868 20.2352C25.5886 20.2352 28.6741 17.2705 28.6741 13.6176C28.6741 9.96469 25.5886 7 21.7868 7C17.985 7 14.8995 9.96469 14.8995 13.6176C14.8995 17.2705 17.985 20.2352 21.7868 20.2352ZM19.3294 22.7181C14.029 22.7181 9.73682 26.8422 9.73682 31.9351C9.73682 32.7822 10.4531 33.4704 11.3347 33.4704H32.2445C33.126 33.4704 33.8423 32.7822 33.8423 31.9351C33.8423 26.8422 29.5502 22.7181 24.2497 22.7181H19.3294Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIa);
export default __webpack_public_path__ + "static/media/CustomerIA.2497ba7ed6ca69a54fa6905eb2ee35fa.svg";
export { ForwardRef as ReactComponent };